import { Packer } from "docx";
import { saveAs } from "file-saver";
import type { AssembledContract, PaperSize } from "../../contracts/types";
import { buildDocument } from "../../docx/buildDocument";

export async function generateDocx(contract: AssembledContract, size: PaperSize = "A4"): Promise<void> {
  const document = buildDocument(contract, size);
  const blob = await Packer.toBlob(document);
  const safe = contract.title.replace(/[^\w\d]+/g, "_").replace(/^_+|_+$/g, "").slice(0, 60) || "contract";
  saveAs(blob, `${safe}.docx`);
}
